import * as React from 'react';
import LockOutlined from './lock-outlined';
import LockFilled from './lock-filled';
import type { IconCombinedProps } from './types';
const LockCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <LockFilled ref={ref} {...rest} />;
  }
  return <LockOutlined ref={ref} {...rest} />;
});
export default LockCombined;